module.exports = __webpack_public_path__ + "img/dani.d79fec7d.png";